"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SearchPlaceInfo = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchPlaceInfo, _React$Component);

  function SearchPlaceInfo(props) {
    var _this;

    _classCallCheck(this, SearchPlaceInfo);

    _this = _possibleConstructorReturn(this, (SearchPlaceInfo.__proto__ || Object.getPrototypeOf(SearchPlaceInfo)).call(this, props));
    _this.onStartSearch = _this.onStartSearch.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchPlaceInfo, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          show = _this$props.show,
          texts = _this$props.texts,
          name = _this$props.name;
      var link = '';
      if (!show) return '';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'comp-search-place-info'
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: 'pulsate'
      }, texts.introduction, "\xA0", /*#__PURE__*/_react.default.createElement("a", {
        id: 'search-place-info-link',
        "data-place-to-search": name,
        href: link,
        onClick: this.onStartSearch,
        title: texts.startSearch
      }, texts.startSearch)));
    }
  }, {
    key: "onStartSearch",
    value: function onStartSearch(e) {
      e.preventDefault();
      this.props.startSearch();
    }
  }]);

  return SearchPlaceInfo;
}(_react.default.Component);

SearchPlaceInfo.defaultProps = {
  show: false
};
SearchPlaceInfo.propTypes = {
  show: _propTypes.default.bool,
  name: _propTypes.default.string,
  texts: _propTypes.default.shape({
    introduction: _propTypes.default.string,
    startSearch: _propTypes.default.string
  }),
  startSearch: _propTypes.default.func.isRequired
};
var _default = SearchPlaceInfo;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search-place-info/index.js
// module id = 885
// module chunks = 0